import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { AdmiralException } from 'admiral-core';

@Component
export class FormMixin<DTO> extends Vue {
  errors: Record<string, string[] | undefined> = {};

  isLoading = false;
  isDone = false;

  exceptionErrors(e: any): Record<string, string> {
    const exception = e.response?.data as AdmiralException | undefined;
    return exception?.errors || {};
  }

  resetErrors(): void {
    this.errors = {};
  }

  resetError(errorKey: string) {
    this.errors = {
      ...this.errors,
      [errorKey]: undefined,
    };
  }

  addError(cond: boolean | string, key: string, message: string) {
    if (cond) {
      this.errors = {
        ...this.errors,
        [key]: [message],
      };
    }
  }
}
